import React from 'react';

const UserInfo = ({ userName, companyName }) => (
  <div>
    <h2 className="text-xs sm:text-sm lg:text-lg font-alexandria font-semibold text-[#111827]">
      {userName || 'Unknown User'}
    </h2>
    {companyName && (
      <p className="text-[10px] md:text-[13px] font-inter font-normal text-[#676767] text-placeholder-text">
      {companyName || ''}
    </p>
    )}
  </div>
);

export default UserInfo;